export default __webpack_public_path__ + "static/donut-33ca1963cb9b9cd03074e6d84cef4c15.svg";